const supportedLanguages = [
  'pl', 'en'
]

const defaultLanguage = 'pl';

module.exports = {
  supportedLanguages,
  defaultLanguage
};
